import Vue from "vue"
import config from '@/config'
import store from '@/store'
/**
 * Created by jiachenpan on 16/11/18.
 */

export function parseTime(time, cFormat) {
  if (arguments.length === 0) {
    return null
  }
  const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}'
  let date
  if (typeof time === 'object') {
    date = time
  } else {
    if (('' + time).length === 10) time = parseInt(time) * 1000
    date = new Date(time)
  }
  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay()
  }
  const time_str = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
    let value = formatObj[key]
    // Note: getDay() returns 0 on Sunday
    if (key === 'a') { return ['日', '一', '二', '三', '四', '五', '六'][value ] }
    if (result.length > 0 && value < 10) {
      value = '0' + value
    }
    return value || 0
  })
  return time_str
}

export function formatTime(time, option) {
  time = +time * 1000
  const d = new Date(time)
  const now = Date.now()

  const diff = (now - d) / 1000

  if (diff < 30) {
    return '刚刚'
  } else if (diff < 3600) {
    // less 1 hour
    return Math.ceil(diff / 60) + '分钟前'
  } else if (diff < 3600 * 24) {
    return Math.ceil(diff / 3600) + '小时前'
  } else if (diff < 3600 * 24 * 2) {
    return '1天前'
  }
  if (option) {
    return parseTime(time, option)
  } else {
    return (
      d.getMonth() +
      1 +
      '月' +
      d.getDate() +
      '日' +
      d.getHours() +
      '时' +
      d.getMinutes() +
      '分'
    )
  }
}

export function checkIfTokenValid(tokenExpiryDate){
  if(!tokenExpiryDate) {
    console.error('token有效期无值');
    return false;
  }
  let nowTime = (new Date()).getTime();
  return tokenExpiryDate * 1000 > nowTime;
}

export function isExternal(path) {
  return /^(https?:|mailto:|tel:)/.test(path)
}
export function getQueryString(name) {
  let reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i');
  console.log('reg',reg)
  let r = window.location.search.substr(1).match(reg);
  console.log('r',r)
  if (r != null) {
    return unescape(r[2]);
  }
  return null;
}
// 随机数字
export function GetRandomNum(Min,Max)
{
  let Range = Max - Min;
  let Rand = Math.random();
  return(Min + Math.round(Rand * Range));
}
// 随机字符串
function GenerateMixed(n) {
  let str = ['0','1','2','3','4','5','6','7','8','9','A','B','C','D','E','F','G','H','I','J','K','L','M','N','O','P','Q','R','S','T','U','V','W','X','Y','Z'];
  let res = "";
  for(let i = 0; i < n ; i ++) {
    let id = Math.ceil(Math.random()*35);
    res += str[id];
  }
  return res;
}
export function login(){
  let locationUrl = window.location.href
  // UniAuth认证
  let url;
  if(config.LOGIN_WAY === 'uniAuth') {
    let uniAuthConfig = JSON.parse(config.AUTH_SETTING);
    uniAuthConfig.state = GetRandomNum(1,999999);
    uniAuthConfig.nonce = GenerateMixed(6);
    store.commit('SET_UNIAITH_NONCE', uniAuthConfig.nonce);
    console.log('uniAuthConfig',uniAuthConfig)
    // url = `${uniAuthConfig.url}idtoken/login?client_id=${uniAuthConfig.client_id}&redirect_uri=${config.VUE_APP_URL}&state=${uniAuthConfig.state}&nonce=${uniAuthConfig.nonce}`
    url = `${uniAuthConfig.url}idtoken/login?client_id=${uniAuthConfig.client_id}&redirect_uri=${config.VUE_APP_URL}&state=${uniAuthConfig.state}&nonce=${uniAuthConfig.nonce}`
    window.location.href = url;
  } else {
    // cas 认证
    // window.location.href = `${config.casUrl}login?service=${process.env.VUE_APP_ADMIN_PLATFORM_URL}`
    // window.location.href = `${config.casUrl}login?service=${process.env.VUE_APP_URL}`
    window.location.href = `${config.casUrl}login?service=${locationUrl}`
  }
}





